import axios from 'axios'

let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched(token) {
  subscribers = subscribers.filter(callback => callback(token))
}

function addSubscriber(callback) {
  subscribers.push(callback)
}

export default function setup (vm) {
	axios.interceptors.request.use(function (config) {
		return config
	}, function (err) {
		return Promise.reject(err)
	})
	axios.interceptors.response.use(function (response) {
		return response
	}, function (error) {
		const { config, response: { status, data } } = error
		const originalRequest = config
		if (status === 401 && vm.$store.state.user != null) {
			if (!isAlreadyFetchingAccessToken) {
				isAlreadyFetchingAccessToken = true
				axios.post(`${vm.$store.state.serverURI}/api/login/refresh`, null, vm.$store.getters.getHeader).then((response) => {
					let token = response.data.access_token
					vm.$store.commit('SET_TOKEN', token)
					if (window.localStorage) {
						localStorage.setItem('token', token)
					}
					isAlreadyFetchingAccessToken = false
					onAccessTokenFetched(token)
				})
			} else {
				if (data.message.includes('refresh_token')) {
					console.log('Not authenticated')
					isAlreadyFetchingAccessToken = false
					localStorage.setItem('route', error.path)
					vm.logout()
					return Promise.reject(error)
				}
			}
			const retryOriginalRequest = new Promise((resolve) => {
				addSubscriber(token => {
					originalRequest.headers.Authorization = 'Bearer ' + token
					resolve(axios(originalRequest))
				})
			})
			return retryOriginalRequest
		}
		return Promise.reject(error)
	})
}



// WEBPACK FOOTER //
// ./src/helpers/interceptors.js